(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  let observer;

  const reveal = (element) => {
    element.classList.add('is-cvb-visible');
    observer?.unobserve(element);
  };

  const revealVisible = () => {
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    document.querySelectorAll('[data-cvb-reveal]:not(.is-cvb-visible)').forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.top < viewportHeight * 0.91 && rect.bottom > 0) reveal(element);
    });
  };

  const buildObserver = () => {
    if (observer || reducedMotion.matches || !('IntersectionObserver' in window)) return;

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, {
      rootMargin: '0px 0px -9% 0px',
      threshold: 0.12
    });
  };

  const mark = (element, variant, delay = 0) => {
    if (!element || element.hasAttribute('data-cvb-reveal')) return;

    element.setAttribute('data-cvb-reveal', variant);
    element.style.setProperty('--cvb-motion-delay', `${Math.min(delay, 280)}ms`);

    if (reducedMotion.matches || !observer) {
      element.classList.add('is-cvb-visible');
      return;
    }

    if (!observed.has(element)) {
      observed.add(element);
      observer.observe(element);
    }
  };

  const prepareSection = (section, index) => {
    if (!section || section.dataset.cvbMotionPrepared === 'true') return;
    if (section.classList.contains('shopify-section--slideshow')) return;

    section.dataset.cvbMotionPrepared = 'true';

    const headings = section.querySelectorAll(
      '.section__header h2, .section__header h3, .section__header .heading, h2.heading, h3.heading'
    );
    headings.forEach((heading, headingIndex) => mark(heading, 'title', headingIndex * 70));

    const image = section.querySelector(
      '.image-with-text__image-wrapper, .image-with-text-block__image-wrapper, .shop-the-look__image-wrapper, .video-wrapper'
    );
    if (image) mark(image, index % 2 === 0 ? 'from-left' : 'from-right');

    const copy = section.querySelector(
      '.image-with-text__content-wrapper, .image-with-text-block__content, .shop-the-look__nav, .testimonial-list'
    );
    if (copy) mark(copy, 'soft', 90);

    const items = section.querySelectorAll(
      '.product-item, .collection-item, .text-with-icons__item, .testimonial, .article-item'
    );
    items.forEach((item, itemIndex) => mark(item, 'rise', 50 + (itemIndex % 5) * 55));

    if (!headings.length && !image && !copy && !items.length) {
      const content = section.querySelector('.section__color-wrapper > .container, .content-box, .rte');
      if (content) mark(content, 'rise');
    }
  };

  const prepare = (scope = document) => {
    buildObserver();

    const sections = scope.matches?.('#main > .shopify-section')
      ? [scope]
      : scope.querySelectorAll?.('#main > .shopify-section') || [];

    sections.forEach(prepareSection);
    document.documentElement.classList.add('cvb-motion-ready');

    if (reducedMotion.matches || !observer) {
      document.querySelectorAll('[data-cvb-reveal]').forEach(reveal);
    } else {
      requestAnimationFrame(revealVisible);
    }
  };

  const init = () => prepare(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  window.addEventListener('load', revealVisible, { once: true });
  window.addEventListener('scroll', revealVisible, { passive: true });
  window.addEventListener('resize', revealVisible, { passive: true });
})();
